import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  createStyles,
  makeStyles,
} from '@bb-ui/react-library';
import { useJobExecutionContext } from 'contexts/JobExecutionContext';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      borderRadius: 12,
      border: '1px solid rgba(0, 0, 0, 0.08)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
    },
    header: {
      padding: '12px 16px 8px',
      '& .MuiCardHeader-title': {
        fontSize: '13px',
        fontWeight: 600,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.5px',
        color: 'rgba(0, 0, 0, 0.45)',
      },
    },
    content: {
      padding: '0 16px 12px',
      flex: 1,
      '&:last-child': {
        paddingBottom: 12,
      },
    },
  }),
);

export interface JobCardProps {
  title: string;
  content: React.ReactNode;
  actions?: React.ReactNode;
  headerAction?: React.ReactNode;
}

export const JobCard: React.FC<JobCardProps> = (props) => {
  const { loading } = useJobExecutionContext();
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader title={props.title} action={props.headerAction} className={classes.header} />
      <CardContent className={classes.content}>
        {loading ? (
          <div>
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
          </div>
        ) : (
          props.content
        )}
      </CardContent>
      {props.actions}
    </Card>
  );
};
